<template>
  <v-row>
    <v-col cols="8">
      <v-select
        v-model="select"
        label="Labels"
        chips
        multiple
        :items="items"
        item-text="name"
        color="primary"
        item-value="id"
      >
        <template
          slot="selection"
          slot-scope="data"
        >
          <v-chip
            :key="JSON.stringify(data.item)"
            color="grey lighten-3"
            :input-value="data.selected"
            :disabled="data.disabled"
          >
            <v-avatar class="primary white--text" left>
              {{ data.item.name.slice(0, 1).toUpperCase() }}
            </v-avatar>
            {{ data.item.name }}
          </v-chip>
        </template>
      </v-select>
    </v-col>
    <v-col cols="4">
      <v-dialog
        v-model="dialog"
        max-width="400px"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            class="mt-3"
            outlined
            color="primary"
            v-on="on"
          >
            <v-icon class="mr-1">
              mdi-plus
            </v-icon>Add label
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">New label</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="new_label"
                  v-validate="'required|min:3|alpha_dash'"
                  label="Name"
                  :error-messages="errors.collect('label')"
                  data-vv-name="label"
                  required
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click.native="close"
            >
              Cancel
            </v-btn>
            <v-btn
              @click.native="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
  import HmdService from './services/HmdService'

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      items: Array,
      currLabels: Array,
    },
    data: () => ({
      new_label: '',
      dialog: false,
      select: [],
    }),
    watch: {
      select: function (val) {
        this.$emit('labels', this.select)
      },
    },
    created () {
      this.select = this.currLabels
    },
    methods: {
      close () {
        this.dialog = false
      },

      save () {
        var t = this
        this.$validator.validateAll()
          .then((result) => {
            if (result) {
              HmdService.label_create(this.new_label, this)
                .then(result => {
                  this.new_label = ''
                  this.items.push(result.data)
                  if (typeof this.select !== 'undefined') {
                    this.select.push(this.items[this.items.length - 1].id)
                  } else {
                    this.select = [this.items[this.items.length - 1].id]
                  }
                  this.close()
                }).catch(function (error) {
                  t.$store.commit('push', { msg: 'label already exists', color: 'error' })
                })
            }
          })
      },
      remove_label (item) {
        console.log(item)
      },
    },
  }
</script>
